import React, { useEffect, useState } from "react";
import StoredLayout from "../../../layouts/StoredLayout";
import { setJumbotronTitle } from "../../../actions/common";
import WithAjax from "../../common/helpers/WithAjax";
import { connect } from "react-redux";
import { AdminMessageCreateForm } from "./components/AdminMessageCreateForm/AdminMessageCreateForm";
import { withRouter } from "react-router";
import { adminMessageChannelsEnum, sendAdminMessageApiCall } from "./utilities/sendAdminMessageApiCall";
import { getSelectedCountryCode, getSubCommunities, getSelectedSubCommunity } from "../../common/functions/countrySetting";

const AdminMessageCreatePage = (props) => {
  const [initialState, setInitialState] = useState({ skillVendorIds: undefined, vacancyId: undefined, vacancyCandidateStatus: undefined, recipients: "" });

  useEffect(() => {
    props.setJumbotronTitle("New Message");

    const query = new URLSearchParams(props.location.search);
    const skillVendorIds = query.get("skillVendorIds") ? query.get("skillVendorIds").split(",") : [];
    const vacancyId = query.get("vacancyId");
    const recipients = query.get("recipients");
    const vacancyCandidateStatus = query.get("vacancyCandidateStatus");
    setInitialState({ skillVendorIds: skillVendorIds, vacancyId: vacancyId, vacancyCandidateStatus: vacancyCandidateStatus, recipients: recipients });
  }, []);

  const onSend = (values) => {
    let subcommunityHeader='';

    let chanels = 0;
    if (values.SMS === true) {
      chanels += adminMessageChannelsEnum.SMS;
    }

    if (values.Email === true) {
      chanels += adminMessageChannelsEnum.Email;
    }

    if (values.Push === true) {
      chanels += adminMessageChannelsEnum.PushNotification;
    }

    if(getSubCommunities() && getSelectedSubCommunity()){
      subcommunityHeader = getSelectedSubCommunity();
    }

    sendAdminMessageApiCall(
      props.ajax,
      {
        RecipientsText: initialState.recipients,
        Title: values.Title,
        Content: values.Content,
        VacancyId: initialState.vacancyId,
        SkillVendorIds: initialState.skillVendorIds ? initialState.skillVendorIds : [],
        VacancyCandidateStatus: initialState.vacancyCandidateStatus,
        Channels: chanels
      },
      props.history,
      subcommunityHeader
    );
  };

  return (
    <div style={{ padding: "0px 20px" }}>
      <AdminMessageCreateForm recipients={initialState.recipients} onSend={onSend} />
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({});
const mapDispatchToProps = (dispatch) => ({
  setJumbotronTitle(title) {
    dispatch(setJumbotronTitle(title));
  },
});

export default StoredLayout(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(WithAjax(AdminMessageCreatePage)))
);
